export const myInsurance = {
  insurance: {
    left_days: '已过期',
    quantity: 1,
    city: '上海市',
    claim_amount: 940,
    created_at: '2018-06-28 03:50:51',
    used_up: false,
    expired_at: '2019-06-27 11:50:51',
    status_label: '已过期',
    left_quantity: 1,
    expired: true,
    province: '上海市',
    can_claim: false,
    claims: [
      {
        tyre_group: 3,
        images: [
          {
            name: 'bcbc26ffb1a542d6a5d74e84c9174b13.jpg',
            thumbnail_file: null,
            id: 510,
            thumbnail_url: null,
            url: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=3363295869,2467511306&fm=26&gp=0.jpg'
          },
          {
            name: '8343d30003db41c6a0c525d505f93c86.jpg',
            thumbnail_file: null,
            id: 511,
            thumbnail_url: null,
            url: 'https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=2853553659,1775735885&fm=26&gp=0.jpg'
          },
          {
            name: 'da182fb796a1463abe2198d90bd71814.jpg',
            thumbnail_file: null,
            id: 513,
            thumbnail_url: null,
            url: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=3363295869,2467511306&fm=26&gp=0.jpg'
          },
          {
            name: '2f008996f09049e6bb8fd97970d1aa49.jpg',
            thumbnail_file: null,
            id: 512,
            thumbnail_url: null,
            url: 'https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=2853553659,1775735885&fm=26&gp=0.jpg'
          }
        ],
        moe: 'MOE',
        quantity: 1,
        city: '上海市',
        claim_amount: 940,
        created_at: '2018-08-13 03:25:27',
        operator: '解海涛',
        spec: '225/40R18',
        status_label: '已批准',
        claim_no: 'TD20180813002',
        province: '上海市',
        order_images: null,
        brand: 'Continental',
        order_id: 434,
        tyre_group_label: '左前轮',
        brand_cn: '马牌',
        order: {
          order_no: 'F920180813002',
          id: 434,
          tyre: {
            mbpn: 'MQALCN89991755',
            quantity: 1,
            subname: '225/40 R18 92W XL 马牌 ContiSportContact 5 SSR FR',
            name: 'A200 / A180 / B200 / B260 / CLA200 / CLA220 / CLA260 原配 MOE',
            pattern: 'ContiSportContact 5 SSR FR',
            short_name: 'CLA260 原配 MOE',
            id: 92,
            brand: {
              code: 'Continental',
              name: '马牌'
            },
            spec: '225/40R18'
          },
          wip_no: null
        },
        status: 2
      }
    ],
    id: 12,
    vehicle_valid: false,
    status: 3
  },
  vehicle: {
    tyres: [
      {
        mbpn: 'MQALCN89991755',
        tyre_group: 1,
        tyre_id: 92,
        moe: 'MOE',
        dot: '1315',
        pattern: 'ContiSportContact 5 SSR FR',
        id: 39,
        brand: 'Continental',
        spec: '225/40R18',
        tyre_group_label: '左前轮',
        brand_cn: '马牌'
      },
      {
        mbpn: 'MQALCN89991755',
        tyre_group: 2,
        tyre_id: 92,
        moe: 'MOE',
        dot: '1416',
        pattern: 'ContiSportContact 5 SSR FR',
        id: 40,
        brand: 'Continental',
        spec: '225/40R18',
        tyre_group_label: '右前轮',
        brand_cn: '马牌'
      },
      {
        mbpn: 'MQALCN89991755',
        tyre_group: 3,
        tyre_id: 92,
        moe: 'MOE',
        dot: '1616',
        pattern: 'ContiSportContact 5 SSR FR',
        id: 41,
        brand: 'Continental',
        spec: '225/40R18',
        tyre_group_label: '左后轮',
        brand_cn: '马牌'
      },
      {
        mbpn: 'MQALCN89991755',
        tyre_group: 4,
        tyre_id: 92,
        moe: 'MOE',
        dot: '1515',
        pattern: 'ContiSportContact 5 SSR FR',
        id: 38,
        brand: 'Continental',
        spec: '225/40R18',
        tyre_group_label: '右后轮',
        brand_cn: '马牌'
      }
    ],
    to_be_added: false,
    city: '上海市',
    vin_code: 'DSFSDFSDFSDFSDFSD',
    bound: true,
    vin_img_url: null,
    mobile: '135****0307',
    created_at: '2018-06-25 07:04:50',
    plate: 'A123',
    encoded_vin: 'DSF**********DFSD',
    province: '上海市',
    series_data: [54, 57],
    qr_url: 'https://aspmo2o-test.mercedes-benz.com.cn/#/user_vehicle?vin_code=DSFSDFSDFSDFSDFSD',
    series: 'CLA级',
    dealer: {
      name: '上海利星汽车维修有限公司',
      tel: '400-166-6789',
      id: 1,
      city_id: 1
    },
    name: 'k**',
    users_id: 2257,
    model: 'CLA 260 4MATIC',
    id: 13,
    purchase_date: '2018-06-28 03:50:48',
    encode_plate: 'A123',
    mileage: 10,
    vehicle_name: 'CLA级 CLA 260 4MATIC'
  }
}
